import React, { Component } from 'react';
import { compose } from 'redux';
import { connectSubpages } from 'app/hocs/subpageManagable';
import DesktopLightbox from 'app/components/base/DesktopLightbox';
import Button from 'app/components/base/Button';
import { FormattedMessage } from 'mz-intl';
import messages from '../messages.intl';
import { Body, Text, Actions, ContinueButton } from './elements';

/**
 * Modal shown when the user tries to book a ride that does not support
 * book now, pay later while the BNPL banner is present on the page.
 * Offers to continue to checkout (pay now) or select another ride.
 */
export class PayLaterUnavailableLightbox extends Component {
  handleClose = () => {
    this.props.subpages.popPage();
  };

  handleContinue = () => {
    // Close the modal WITHOUT popPage(): popPage() calls history.goBack(), which
    // races against the checkout navigation fired by onContinue() (history.push
    // ('/book') or window.location.href) and undoes it, stranding the user on the
    // SRP. removeAll() clears the subpage stack via forceUpdate with no history
    // change, so the modal closes and the booking navigation is left to win.
    this.props.subpages.removeAll();
    this.props.onContinue();
  };

  render() {
    return (
      <DesktopLightbox rounded shadow empty onClickClose={this.handleClose}>
        <Body>
          <Text>
            <FormattedMessage message={messages.PAY_LATER_UNAVAILABLE_TEXT} />
          </Text>
          <Actions>
            <Button outlined nocaps onClick={this.handleClose}>
              <FormattedMessage
                message={messages.PAY_LATER_UNAVAILABLE_SELECT_ANOTHER}
              />
            </Button>
            <ContinueButton nocaps onClick={this.handleContinue}>
              <FormattedMessage
                message={messages.PAY_LATER_UNAVAILABLE_CONTINUE}
              />
            </ContinueButton>
          </Actions>
        </Body>
      </DesktopLightbox>
    );
  }
}

export default compose(connectSubpages())(PayLaterUnavailableLightbox);
